import { Space, Tag, Input } from 'antd';
import { formatDate, formatDateTime, formateMdnNumber, formatNumberWithCommas, formatDateByFormate, phoneNumber } from '../../../src/components/Common/Extensions';
import { Tooltip } from 'antd';
import UserPlaceholder from "../../assets/img/userPlaceholder.svg";
import ImgPlaceholder from "../../assets/img/shop/ProductPlaceholder.svg";
import { Typography, Grid, InputBase, Button } from "@material-ui/core";
import './style.css';
import { EyeOutlined } from '@ant-design/icons';
import GiftIcon from '@material-ui/core/SvgIcon';
import GrantReceived from '../../pages/grants/programs/programDetails/grantReceived/GrantReceived';
const formatCurrency = (value) => {
    if (typeof value !== 'number' || isNaN(value)) {
        return '';
    }

    if (value >= 1000) {
        return `$${(value / 1000).toFixed(1)}k`;
    }

    return `$${value}`;
};
export const data = {

    donationsPaid: [
        {
            title: '',
            dataIndex: 'giftSent',
            className: "width40",
        },

        {
            title: 'Name',
            dataIndex: 'fullName',
            className: "width140",
            sorter: (a, b) => {
                a = a.fullName != null ? a.fullName.toString() : "";
                b = b.fullName != null ? b.fullName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Email',
            dataIndex: 'emailAddress',
            className: "width140",
            sorter: (a, b) => {
                a = a.emailAddress != null ? a.emailAddress.toString() : "";
                b = b.emailAddress != null ? b.emailAddress.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Phone #',
            dataIndex: 'formatedPhone',
            className: "width140",
            sorter: (a, b) => {
                a = a.formatedPhone != null ? a.formatedPhone.toString() : "";
                b = b.formatedPhone != null ? b.formatedPhone.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Address',
            dataIndex: 'completeAddress',
            className: "width140",
            sorter: (a, b) => {
                a = a.completeAddress != null ? a.completeAddress.toString() : "";
                b = b.completeAddress != null ? b.completeAddress.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Amount',
            dataIndex: 'paidAmount',
            className: "width140",
            sorter: (a, b) => {
                a = a.paidAmount != null ? a.paidAmount.toString() : "";
                b = b.paidAmount != null ? b.paidAmount.toString() : "";
                return a.localeCompare(b);
            },
        },
        //{
        //    title: 'Payment Gateway',
        //    dataIndex: 'paymentGateway',
        //    className: "width140",
        //    sorter: (a, b) => {
        //        a = a.paymentGateway != null ? a.paymentGateway.toString() : "";
        //        b = b.paymentGateway != null ? b.paymentGateway.toString() : "";
        //        return a.localeCompare(b);
        //    },
        //},
        {
            title: 'IP',
            dataIndex: 'clientIP',
            className: "width140",
            sorter: (a, b) => {
                a = a.paymentGateway != null ? a.paymentGateway.toString() : "";
                b = b.paymentGateway != null ? b.paymentGateway.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Status',
            dataIndex: 'transactionStatus',
            className: "width140",
            sorter: (a, b) => {
                a = a.transactionStatus != null ? a.transactionStatus.toString() : "";
                b = b.transactionStatus != null ? b.transactionStatus.toString() : "";
                return a.localeCompare(b);
            },
        },

        {
            title: 'Date/Time',
            dataIndex: 'createDate',
            className: "width140",
            sorter: (a, b) => {
                a = a.createDate != null ? a.createDate.toString() : "";
                b = b.createDate != null ? b.createDate.toString() : "";
                return a.localeCompare(b);
            },
        },

        {
            title: 'Action',
            dataIndex: 'donationGridAction',
            className: "width140 textCenter",
            sorter: (a, b) => {
                a = a.donationGridAction != null ? a.donationGridAction.toString() : "";
                b = b.donationGridAction != null ? b.donationGridAction.toString() : "";
                return a.localeCompare(b);
            },
        },
    ],
    donationRequest: [
        {
            title: 'Donation Partner',
            dataIndex: 'fullName',
            className: "width140",
            sorter: (a, b) => {
                a = a.fullName != null ? a.fullName.toString() : "";
                b = b.fullName != null ? b.fullName.toString() : "";
                return a.localeCompare(b);
            },
        },

        {
            title: 'Request Date',
            dataIndex: 'createDate',
            className: "width140",
            sorter: (a, b) => {
                a = a.createDate != null ? a.createDate.toString() : "";
                b = b.createDate != null ? b.createDate.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return formatDate(text);
            }
        },

        {
            title: 'Email Sent',
            dataIndex: 'isEmailSent',
            className: "width140",
            sorter: (a, b) => {
                a = a.isEmailSent != null ? a.isEmailSent.toString() : "";
                b = b.isEmailSent != null ? b.isEmailSent.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return text == true ? 'Yes' : 'No';
            }
        },

        {
            title: 'Action',
            dataIndex: 'donationRequestAction',
            className: "width140 textCenter",
            sorter: (a, b) => {
                a = a.action != null ? a.action.toString() : "";
                b = b.action != null ? b.action.toString() : "";
                return a.localeCompare(b);
            },
        },

    ],
    addressBook: [
        {
            title: 'Company Name',
            dataIndex: 'companyName',
            className: "width140",
            sorter: (a, b) => {
                a = a.companyName != null ? a.companyName.toString() : "";
                b = b.companyName != null ? b.companyName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Name',
            dataIndex: 'fullName',
            className: "width140",
            sorter: (a, b) => {
                a = a.fullName != null ? a.fullName.toString() : "";
                b = b.fullName != null ? b.fullName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Email',
            dataIndex: 'email',
            className: "width140",
            sorter: (a, b) => {
                a = a.email != null ? a.email.toString() : "";
                b = b.email != null ? b.email.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Phone #',
            dataIndex: 'phoneNumber',
            className: "width140",
            sorter: (a, b) => {
                a = a.phoneNumber != null ? a.phoneNumber.toString() : "";
                b = b.phoneNumber != null ? b.phoneNumber.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Address',
            dataIndex: 'completeAddress',
            className: "width140",
            sorter: (a, b) => {
                a = a.completeAddress != null ? a.completeAddress.toString() : "";
                b = b.completeAddress != null ? b.completeAddress.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Notes',
            dataIndex: 'notesHTML',
            className: "width140",
            sorter: (a, b) => {
                a = a.notesHTML != null ? a.notesHTML.toString() : "";
                b = b.notesHTML != null ? b.notesHTML.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Actions',
            dataIndex: 'addressAction',
            className: "commonActionWidth",
        },
    ],
    DomesticOrderTracking: [
        {
            title: 'Created By',
            dataIndex: 'createdByName',
            className: "width140",
            sorter: (a, b) => {
                a = a.createdByName != null ? a.createdByName.toString() : "";
                b = b.createdByName != null ? b.createdByName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Tracking Number',
            dataIndex: 'trackingNumber',
            className: "width140",
            sorter: (a, b) => {
                a = a.trackingNumber != null ? a.trackingNumber.toString() : "";
                b = b.trackingNumber != null ? b.trackingNumber.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Name',
            dataIndex: 'attentionTo',
            className: "width140",
            sorter: (a, b) => {
                a = a.attentionTo != null ? a.attentionTo.toString() : "";
                b = b.attentionTo != null ? b.attentionTo.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Phone #',
            dataIndex: 'phone',
            className: "width140",
            sorter: (a, b) => {
                a = a.phone != null ? a.phone.toString() : "";
                b = b.phone != null ? b.phone.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Status',
            dataIndex: 'statusLabel',
            className: "width140",
            sorter: (a, b) => {
                a = a.statusLabel != null ? a.statusLabel.toString() : "";
                b = b.statusLabel != null ? b.statusLabel.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Last Scan',
            dataIndex: 'lastScanned',
            className: "width140",
            sorter: (a, b) => {
                a = a.lastScanned != null ? a.lastScanned.toString() : "";
                b = b.lastScanned != null ? b.lastScanned.toString() : "";
                return a.localeCompare(b);
            },
        },

        {
            title: 'Actions',
            dataIndex: 'orderTrackingAction',
            className: "width140 textCenter",
        },

    ],
    addressBookInsertList: [
        {
            title: 'Company Name',
            dataIndex: 'companyName',
            className: "width140",
            sorter: (a, b) => {
                a = a.companyName != null ? a.companyName.toString() : "";
                b = b.companyName != null ? b.companyName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Name',
            dataIndex: 'fullName',
            className: "width140",
            sorter: (a, b) => {
                a = a.fullName != null ? a.fullName.toString() : "";
                b = b.fullName != null ? b.fullName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Email',
            dataIndex: 'email',
            className: "width140",
            sorter: (a, b) => {
                a = a.email != null ? a.email.toString() : "";
                b = b.email != null ? b.email.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Phone #',
            dataIndex: 'phoneNumber',
            className: "width140",
            sorter: (a, b) => {
                a = a.phoneNumber != null ? a.phoneNumber.toString() : "";
                b = b.phoneNumber != null ? b.phoneNumber.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Address',
            dataIndex: 'completeAddress',
            className: "width140",
            sorter: (a, b) => {
                a = a.completeAddress != null ? a.completeAddress.toString() : "";
                b = b.completeAddress != null ? b.completeAddress.toString() : "";
                return a.localeCompare(b);
            },
        },
    ],
    ReviewsData: [
        {
            title: 'Date Requested',
            dataIndex: 'createDate',
            className: "width140",
            sorter: (a, b) => {
                a = a.createDate != null ? a.createDate.toString() : "";
                b = b.createDate != null ? b.createDate.toString() : "";
                return a.localeCompare(b);
            },
            render: text => {
                return formatDateTime(text);

            }
        },
        {
            title: 'Employee Name',
            dataIndex: 'employeeName',
            className: "width140",
            sorter: (a, b) => {
                a = a.employeeName != null ? a.employeeName.toString() : "";
                b = b.employeeName != null ? b.employeeName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Name',
            dataIndex: 'fullName',
            className: "width140",
            sorter: (a, b) => {
                a = a.fullName != null ? a.fullName.toString() : "";
                b = b.fullName != null ? b.fullName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Email',
            dataIndex: 'emailAddress',
            className: "width140",
            sorter: (a, b) => {
                a = a.emailAddress != null ? a.emailAddress.toString() : "";
                b = b.emailAddress != null ? b.emailAddress.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Reviews For',
            dataIndex: 'templateCode',
            className: "width140",
            sorter: (a, b) => {
                a = a.templateCode != null ? a.templateCode.toString() : "";
                b = b.templateCode != null ? b.templateCode.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Program',
            dataIndex: 'reviewTo',
            className: "width140",
            sorter: (a, b) => {
                a = a.reviewTo != null ? a.reviewTo.toString() : "";
                b = b.reviewTo != null ? b.reviewTo.toString() : "";
                return a.localeCompare(b);
            },
        },

        /*   {
               title: 'Email Opened',
               dataIndex: 'EmailOpened',
               className: "width140",
               sorter: (a, b) => {
                   a = a.EmailOpened != null ? a.EmailOpened.toString() : "";
                   b = b.EmailOpened != null ? b.EmailOpened.toString() : "";
                   return a.localeCompare(b);
               },
           },*/
        /*{
            title: 'Service',
            dataIndex: 'Service',
            className: "width140",
            sorter: (a, b) => {
                a = a.Service != null ? a.Service.toString() : "";
                b = b.Service != null ? b.Service.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Notification',
            dataIndex: 'Notification',
            className: "width140",
            sorter: (a, b) => {
                a = a.Notification != null ? a.Notification.toString() : "";
                b = b.Notification != null ? b.Notification.toString() : "";
                return a.localeCompare(b);
            },
        },*/
        {
            title: 'Status',
            dataIndex: 'reviewStatus',
            className: "width140",
            sorter: (a, b) => {
                a = a.reviewStatus != null ? a.reviewStatus.toString() : "";
                b = b.reviewStatus != null ? b.reviewStatus.toString() : "";
                return a.localeCompare(b);
            },
        },
        /* {
             title: 'Action',
             dataIndex: 'Action',
             className: "width140",
             sorter: (a, b) => {
                 a = a.Action != null ? a.Action.toString() : "";
                 b = b.Action != null ? b.Action.toString() : "";
                 return a.localeCompare(b);
             },
         },
         */

    ],

    SheilaTabletsRequests: [
        {
            dataIndex: 'healthCareTabletConfirmation',
            className: "width10",
        },
        {
            title: 'Application ID',
            dataIndex: 'applicationId',
            className: "width100 ",
            sorter: (a, b) => {
                a = a.applicationId != null ? a.applicationId.toString() : "";
                b = b.applicationId != null ? b.applicationId.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return `F-${text}`
            }
        },
        {
            title: 'Name',
            dataIndex: 'fullName',
            className: "width140",
            sorter: (a, b) => {
                a = a.fullName != null ? a.fullName.toString() : "";
                b = b.fullName != null ? b.fullName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Email',
            dataIndex: 'emailAddress',
            className: "width140",
            sorter: (a, b) => {
                a = a.emailAddress != null ? a.emailAddress.toString() : "";
                b = b.emailAddress != null ? b.emailAddress.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return <a href={`mailto:${text}`}>{text}</a>
            },
        },
        {
            title: 'Phone #',
            dataIndex: 'formatedPhone',
            className: "width80",
            sorter: (a, b) => {
                a = a.formatedPhone != null ? a.formatedPhone.toString() : "";
                b = b.formatedPhone != null ? b.formatedPhone.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return < a href={`tel:${phoneNumber(text)}`} > {text}</a>
            },

        },
        {
            title: 'Pickup Date/Time',
            dataIndex: 'pickupDateTime',
            className: "width120",
            sorter: (a, b) => {
                a = a.pickupDateTime != null ? a.pickupDateTime.toString() : "";
                b = b.pickupDateTime != null ? b.pickupDateTime.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return formatDateTime(text);
            }
        },
        {
            title: 'Address',
            dataIndex: 'completeAddress',
            className: "width230",
            sorter: (a, b) => {
                a = a.completeAddress != null ? a.completeAddress.toString() : "";
                b = b.completeAddress != null ? b.completeAddress.toString() : "";
                return a.localeCompare(b);
            },
        },


        //{
        //    title: 'Status',
        //    dataIndex: 'status',
        //    className: "width90",
        //    sorter: (a, b) => {
        //        a = a.status != null ? a.status.toString() : "";
        //        b = b.status != null ? b.status.toString() : "";
        //        return a.localeCompare(b);
        //    },
        //},
        {
            title: 'Action',
            dataIndex: 'sheilaActions',
            className: "width100",
            //sorter: (a, b) => {
            //    a = a.action != null ? a.action.toString() : "";
            //    b = b.action != null ? b.action.toString() : "";
            //    return a.localeCompare(b);
            //},
        },


    ],
    SheilaTabletsEnrolled: [
        {
            dataIndex: 'healthCareTabletConfirmation',
            className: "width10",
        },

        {
            title: 'Application ID',
            dataIndex: 'applicationId',
            className: "width100 ",
            sorter: (a, b) => {
                a = a.applicationId != null ? a.applicationId.toString() : "";
                b = b.applicationId != null ? b.applicationId.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return `F-${text}`
            }
        },
        {
            title: 'Name',
            dataIndex: 'fullName',
            className: "width140",
            sorter: (a, b) => {
                a = a.fullName != null ? a.fullName.toString() : "";
                b = b.fullName != null ? b.fullName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Email',
            dataIndex: 'emailAddress',
            className: "width140",
            sorter: (a, b) => {
                a = a.emailAddress != null ? a.emailAddress.toString() : "";
                b = b.emailAddress != null ? b.emailAddress.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return <a href={`mailto:${text}`}>{text}</a>
            },
        },
        {
            title: 'Phone #',
            dataIndex: 'formatedPhone',
            className: "width80",
            sorter: (a, b) => {
                a = a.formatedPhone != null ? a.formatedPhone.toString() : "";
                b = b.formatedPhone != null ? b.formatedPhone.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return < a href={`tel:${phoneNumber(text)}`} > {text}</a>
            },

        },

        {
            title: 'Device ID',
            dataIndex: 'deviceIdentification',
            className: "width140",
            sorter: (a, b) => {
                a = a.deviceIdentification != null ? a.deviceIdentification.toString() : "";
                b = b.deviceIdentification != null ? b.deviceIdentification.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'SIM Number',
            dataIndex: 'icc',
            className: "width140",
            sorter: (a, b) => {
                a = a.icc != null ? a.icc.toString() : "";
                b = b.icc != null ? b.icc.toString() : "";
                return a.localeCompare(b);
            },
        },

        //{
        //    title: 'Status',
        //    dataIndex: 'status',
        //    className: "width100",
        //    sorter: (a, b) => {
        //        a = a.status != null ? a.status.toString() : "";
        //        b = b.status != null ? b.status.toString() : "";
        //        return a.localeCompare(b);
        //    },
        //},
        {
            title: 'Action',
            dataIndex: 'sheilaActions',
            className: "width140",
            //sorter: (a, b) => {
            //    a = a.action != null ? a.action.toString() : "";
            //    b = b.action != null ? b.action.toString() : "";
            //    return a.localeCompare(b);
            //},
        },


    ],
    SheilaTabletsRejected: [
        //{
        //    dataIndex: 'healthCareTabletConfirmation',
        //    className: "width10",
        //},

        {
            title: 'Application ID',
            dataIndex: 'applicationId',
            className: "width100 ",
            sorter: (a, b) => {
                a = a.applicationId != null ? a.applicationId.toString() : "";
                b = b.applicationId != null ? b.applicationId.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return `F-${text}`
            }
        },
        {
            title: 'Name',
            dataIndex: 'fullName',
            className: "width140",
            sorter: (a, b) => {
                a = a.fullName != null ? a.fullName.toString() : "";
                b = b.fullName != null ? b.fullName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Email',
            dataIndex: 'emailAddress',
            className: "width140",
            sorter: (a, b) => {
                a = a.emailAddress != null ? a.emailAddress.toString() : "";
                b = b.emailAddress != null ? b.emailAddress.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return <a href={`mailto:${text}`}>{text}</a>
            },
        },
        {
            title: 'Phone #',
            dataIndex: 'formatedPhone',
            className: "width80",
            sorter: (a, b) => {
                a = a.formatedPhone != null ? a.formatedPhone.toString() : "";
                b = b.formatedPhone != null ? b.formatedPhone.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return < a href={`tel:${phoneNumber(text)}`} > {text}</a>
            },

        },

        //{
        //    title: 'Device ID',
        //    dataIndex: 'deviceIdentification',
        //    className: "width140",
        //    sorter: (a, b) => {
        //        a = a.deviceIdentification != null ? a.deviceIdentification.toString() : "";
        //        b = b.deviceIdentification != null ? b.deviceIdentification.toString() : "";
        //        return a.localeCompare(b);
        //    },
        //},
        //{
        //    title: 'SIM Number',
        //    dataIndex: 'icc',
        //    className: "width140",
        //    sorter: (a, b) => {
        //        a = a.icc != null ? a.icc.toString() : "";
        //        b = b.icc != null ? b.icc.toString() : "";
        //        return a.localeCompare(b);
        //    },
        //},

        //{
        //    title: 'Status',
        //    dataIndex: 'status',
        //    className: "width100",
        //    sorter: (a, b) => {
        //        a = a.status != null ? a.status.toString() : "";
        //        b = b.status != null ? b.status.toString() : "";
        //        return a.localeCompare(b);
        //    },
        //},

        {
            title: 'Rejected By',
            dataIndex: 'rejectedByName',
            className: "width100",
            sorter: (a, b) => {
                a = a.rejectedByName != null ? a.rejectedByName.toString() : "";
                b = b.rejectedByName != null ? b.rejectedByName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Rejected Date',
            dataIndex: 'rejectedDate',
            className: "width120",
            sorter: (a, b) => {
                a = a.rejectedDate != null ? a.rejectedDate.toString() : "";
                b = b.rejectedDate != null ? b.rejectedDate.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Action',
            dataIndex: 'sheilaActions',
            className: "width140",
            //sorter: (a, b) => {
            //    a = a.action != null ? a.action.toString() : "";
            //    b = b.action != null ? b.action.toString() : "";
            //    return a.localeCompare(b);
            //},
        },


    ],
    SheilaTabletsDelivered: [
        {
            dataIndex: "simActivated",
            className: "width30",
        },
        {
            title: 'Application ID',
            dataIndex: 'applicationId',
            className: "width100 ",
            sorter: (a, b) => {
                a = a.applicationId != null ? a.applicationId.toString() : "";
                b = b.applicationId != null ? b.applicationId.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return `F-${text}`
            }
        },
        {
            title: 'Name',
            dataIndex: 'fullName',
            className: "width140",
            sorter: (a, b) => {
                a = a.fullName != null ? a.fullName.toString() : "";
                b = b.fullName != null ? b.fullName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Email',
            dataIndex: 'emailAddress',
            className: "width140",
            sorter: (a, b) => {
                a = a.emailAddress != null ? a.emailAddress.toString() : "";
                b = b.emailAddress != null ? b.emailAddress.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return <a href={`mailto:${text}`}>{text}</a>
            },
        },
        //{
        //    title: 'Phone #',
        //    dataIndex: 'formatedPhone',
        //    className: "width80",
        //    sorter: (a, b) => {
        //        a = a.formatedPhone != null ? a.formatedPhone.toString() : "";
        //        b = b.formatedPhone != null ? b.formatedPhone.toString() : "";
        //        return a.localeCompare(b);
        //    },
        //    render: (text) => {
        //        return < a href={`tel:${phoneNumber(text)}`} > {text}</a>
        //    },

        //},
        {
            title: 'Delivery Date',
            dataIndex: 'deliveryDate',
            className: "width140",
            sorter: (a, b) => {
                a = a.deliveryDate != null ? a.deliveryDate.toString() : "";
                b = b.deliveryDate != null ? b.deliveryDate.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Device ID',
            dataIndex: 'deviceIdentification',
            className: "width140",
            sorter: (a, b) => {
                a = a.deviceIdentification != null ? a.deviceIdentification.toString() : "";
                b = b.deviceIdentification != null ? b.deviceIdentification.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'SIM Number',
            dataIndex: 'icc',
            className: "width140",
            sorter: (a, b) => {
                a = a.icc != null ? a.icc.toString() : "";
                b = b.icc != null ? b.icc.toString() : "";
                return a.localeCompare(b);
            },
        },

        //{
        //    title: 'Status',
        //    dataIndex: 'status',
        //    className: "width100",
        //    sorter: (a, b) => {
        //        a = a.status != null ? a.status.toString() : "";
        //        b = b.status != null ? b.status.toString() : "";
        //        return a.localeCompare(b);
        //    },
        //},
        {
            title: 'Action',
            dataIndex: 'sheilaActions',
            className: "width140",
            //sorter: (a, b) => {
            //    a = a.action != null ? a.action.toString() : "";
            //    b = b.action != null ? b.action.toString() : "";
            //    return a.localeCompare(b);
            //},
        },


    ],

    PalmBeachTabletsRequests: [
        {
            dataIndex: 'healthCareTabletConfirmation',
            className: "width10",
        },
        {
            title: 'Application ID',
            dataIndex: 'formatedApplicationId',
            className: "width100 ",
            sorter: (a, b) => {
                a = a.formatedApplicationId != null ? a.formatedApplicationId.toString() : "";
                b = b.formatedApplicationId != null ? b.formatedApplicationId.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Name',
            dataIndex: 'fullName',
            className: "width130",
            sorter: (a, b) => {
                a = a.fullName != null ? a.fullName.toString() : "";
                b = b.fullName != null ? b.fullName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Email',
            dataIndex: 'emailAddress',
            className: "width140",
            sorter: (a, b) => {
                a = a.emailAddress != null ? a.emailAddress.toString() : "";
                b = b.emailAddress != null ? b.emailAddress.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return <a href={`mailto:${text}`}>{text}</a>
            },
        },
        {
            title: 'Phone #',
            dataIndex: 'formatedPhone',
            className: "width120",
            sorter: (a, b) => {
                a = a.formatedPhone != null ? a.formatedPhone.toString() : "";
                b = b.formatedPhone != null ? b.formatedPhone.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return < a href={`tel:${phoneNumber(text)}`} > {text}</a>
            },

        },
        {
            title: 'Pickup Date/Time',
            dataIndex: 'pickupDateTime',
            className: "width120",
            sorter: (a, b) => {
                a = a.pickupDateTime != null ? a.pickupDateTime.toString() : "";
                b = b.pickupDateTime != null ? b.pickupDateTime.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return formatDateTime(text);
            }
        },
        {
            title: 'No. of Devices',
            dataIndex: 'deviceCount',
            className: "width120",
            sorter: (a, b) => {
                a = a.deviceCount != null ? a.deviceCount.toString() : "";
                b = b.deviceCount != null ? b.deviceCount.toString() : "";
                return a.localeCompare(b);
            },
        },

        {
            title: 'Action',
            dataIndex: 'palmBeachActions',
            className: "width140 textCenter",
        },


    ],
    PalmBeachTabletsRejected: [
        {
            title: 'Application ID',
            dataIndex: 'formatedApplicationId',
            className: "width100 ",
            sorter: (a, b) => {
                a = a.formatedApplicationId != null ? a.formatedApplicationId.toString() : "";
                b = b.formatedApplicationId != null ? b.formatedApplicationId.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Name',
            dataIndex: 'fullName',
            className: "width140",
            sorter: (a, b) => {
                a = a.fullName != null ? a.fullName.toString() : "";
                b = b.fullName != null ? b.fullName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Email',
            dataIndex: 'emailAddress',
            className: "width140",
            sorter: (a, b) => {
                a = a.emailAddress != null ? a.emailAddress.toString() : "";
                b = b.emailAddress != null ? b.emailAddress.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return <a href={`mailto:${text}`}>{text}</a>
            },
        },
        {
            title: 'Phone #',
            dataIndex: 'formatedPhone',
            className: "width80",
            sorter: (a, b) => {
                a = a.formatedPhone != null ? a.formatedPhone.toString() : "";
                b = b.formatedPhone != null ? b.formatedPhone.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return < a href={`tel:${phoneNumber(text)}`} > {text}</a>
            },

        },

        {
            title: 'Rejected By',
            dataIndex: 'rejectedByName',
            className: "width100",
            sorter: (a, b) => {
                a = a.rejectedByName != null ? a.rejectedByName.toString() : "";
                b = b.rejectedByName != null ? b.rejectedByName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Rejected Date',
            dataIndex: 'rejectedDate',
            className: "width120",
            sorter: (a, b) => {
                a = a.rejectedDate != null ? a.rejectedDate.toString() : "";
                b = b.rejectedDate != null ? b.rejectedDate.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Action',
            dataIndex: 'palmBeachActions',
            className: "width140 textCenter",

        },


    ],
    PalmBeachTabletsDelivered: [
        {
            title: 'Application ID',
            dataIndex: 'formatedApplicationId',
            className: "width100 ",
            sorter: (a, b) => {
                a = a.formatedApplicationId != null ? a.formatedApplicationId.toString() : "";
                b = b.formatedApplicationId != null ? b.formatedApplicationId.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Name',
            dataIndex: 'fullName',
            className: "width140",
            sorter: (a, b) => {
                a = a.fullName != null ? a.fullName.toString() : "";
                b = b.fullName != null ? b.fullName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Email',
            dataIndex: 'emailAddress',
            className: "width140",
            sorter: (a, b) => {
                a = a.emailAddress != null ? a.emailAddress.toString() : "";
                b = b.emailAddress != null ? b.emailAddress.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return <a href={`mailto:${text}`}>{text}</a>
            },
        },

        {
            title: 'Delivery Date',
            dataIndex: 'deliveryDate',
            className: "width140",
            sorter: (a, b) => {
                a = a.deliveryDate != null ? a.deliveryDate.toString() : "";
                b = b.deliveryDate != null ? b.deliveryDate.toString() : "";
                return a.localeCompare(b);
            },
        },

        {
            title: 'No. of Devices',
            dataIndex: 'deviceCount',
            className: "width120",
            sorter: (a, b) => {
                a = a.deviceCount != null ? a.deviceCount.toString() : "";
                b = b.deviceCount != null ? b.deviceCount.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Action',
            dataIndex: 'palmBeachActions',
            className: "width140 textCenter",

        },


    ],


    floridaConnectApplicantLog: [
        {
            title: 'Date',
            dataIndex: 'createdOn',
            className: "width130 textCenter",
            sorter: (a, b) => {
                a = a.createdOn != null ? a.createdOn.toString() : "";
                b = b.createdOn != null ? b.createdOn.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return formatDateTime(text);
            }
        },
        {
            title: 'Zip Code',
            dataIndex: 'zipCode',
            className: "width130 textCenter",
            sorter: (a, b) => {
                a = a.zipCode != null ? a.zipCode.toString() : "";
                b = b.zipCode != null ? b.zipCode.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Phone',
            dataIndex: 'phone',
            className: "width200 textCenter",
            sorter: (a, b) => {
                a = a.phone != null ? a.phone.toString() : "";
                b = b.phone != null ? b.phone.toString() : "";
                return a.localeCompare(b);
            },

        },
        // {
        //     title: 'Action',
        //     dataIndex: 'commonAction',
        //     className: "width140 textCenter",
        // }

    ],

    FloridaConnectedRequests: [
        // {
        //     dataIndex: 'healthCareTabletConfirmation',
        //     className: "width10",
        // },
        {
            title: 'Application ID',
            dataIndex: 'formatedApplicationId',
            className: "width100 textCenter",
            sorter: (a, b) => {
                a = a.formatedApplicationId != null ? a.formatedApplicationId.toString() : "";
                b = b.formatedApplicationId != null ? b.formatedApplicationId.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Name',
            dataIndex: 'fullName',
            className: "width130",
            sorter: (a, b) => {
                a = a.fullName != null ? a.fullName.toString() : "";
                b = b.fullName != null ? b.fullName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Email',
            dataIndex: 'emailAddress',
            className: "width140",
            sorter: (a, b) => {
                a = a.emailAddress != null ? a.emailAddress.toString() : "";
                b = b.emailAddress != null ? b.emailAddress.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return <a href={`mailto:${text}`}>{text}</a>
            },
        },
        {
            title: 'Phone #',
            dataIndex: 'formatedPhone',
            className: "width100",
            sorter: (a, b) => {
                a = a.formatedPhone != null ? a.formatedPhone.toString() : "";
                b = b.formatedPhone != null ? b.formatedPhone.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return < a href={`tel:${phoneNumber(text)}`} > {text}</a>
            },

        },
        {
            title: 'Referring Organization',
            dataIndex: 'refOrganization',
            className: "width100 textCenter",
            sorter: (a, b) => {
                a = a.refOrganization != null ? a.refOrganization.toString() : "";
                b = b.refOrganization != null ? b.refOrganization.toString() : "";
                return a.localeCompare(b);
            },
        },

        {
            title: 'Apply For',
            dataIndex: 'applyFor',
            className: "width100 textCenter",
            sorter: (a, b) => {
                a = a.applyFor != null ? a.applyFor.toString() : "";
                b = b.applyFor != null ? b.applyFor.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'No. of Devices',
            dataIndex: 'deviceCount',
            className: "width120 textCenter",
            sorter: (a, b) => {
                a = a.deviceCount != null ? a.deviceCount.toString() : "";
                b = b.deviceCount != null ? b.deviceCount.toString() : "";
                return a.localeCompare(b);
            },
        },

        {
            title: 'Action',
            dataIndex: 'floridaAction',
            className: "width140 textCenter",
        },


    ],
    FloridaConnectRejected: [
        {
            title: 'Application ID',
            dataIndex: 'formatedApplicationId',
            className: "width100 textCenter",
            sorter: (a, b) => {
                a = a.formatedApplicationId != null ? a.formatedApplicationId.toString() : "";
                b = b.formatedApplicationId != null ? b.formatedApplicationId.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Name',
            dataIndex: 'fullName',
            className: "width140",
            sorter: (a, b) => {
                a = a.fullName != null ? a.fullName.toString() : "";
                b = b.fullName != null ? b.fullName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Email',
            dataIndex: 'emailAddress',
            className: "width140",
            sorter: (a, b) => {
                a = a.emailAddress != null ? a.emailAddress.toString() : "";
                b = b.emailAddress != null ? b.emailAddress.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return <a href={`mailto:${text}`}>{text}</a>
            },
        },
        {
            title: 'Phone #',
            dataIndex: 'formatedPhone',
            className: "width80",
            sorter: (a, b) => {
                a = a.formatedPhone != null ? a.formatedPhone.toString() : "";
                b = b.formatedPhone != null ? b.formatedPhone.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return < a href={`tel:${phoneNumber(text)}`} > {text}</a>
            },

        },

        {
            title: 'Referring Organization',
            dataIndex: 'refOrganization',
            className: "width100 textCenter",
            sorter: (a, b) => {
                a = a.refOrganization != null ? a.refOrganization.toString() : "";
                b = b.refOrganization != null ? b.refOrganization.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Apply For',
            dataIndex: 'applyFor',
            className: "width100 textCenter",
            sorter: (a, b) => {
                a = a.applyFor != null ? a.applyFor.toString() : "";
                b = b.applyFor != null ? b.applyFor.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Rejected By',
            dataIndex: 'rejectedByName',
            className: "width100",
            sorter: (a, b) => {
                a = a.rejectedByName != null ? a.rejectedByName.toString() : "";
                b = b.rejectedByName != null ? b.rejectedByName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Rejected Date',
            dataIndex: 'rejectedDate',
            className: "width120",
            sorter: (a, b) => {
                a = a.rejectedDate != null ? a.rejectedDate.toString() : "";
                b = b.rejectedDate != null ? b.rejectedDate.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Action',
            dataIndex: 'floridaAction',
            className: "width140 textCenter",

        },


    ],
    FloridaConnectDelivered: [
        {
            title: 'Application ID',
            dataIndex: 'formatedApplicationId',
            className: "width100 ",
            sorter: (a, b) => {
                a = a.formatedApplicationId != null ? a.formatedApplicationId.toString() : "";
                b = b.formatedApplicationId != null ? b.formatedApplicationId.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Name',
            dataIndex: 'fullName',
            className: "width140",
            sorter: (a, b) => {
                a = a.fullName != null ? a.fullName.toString() : "";
                b = b.fullName != null ? b.fullName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Email',
            dataIndex: 'emailAddress',
            className: "width140",
            sorter: (a, b) => {
                a = a.emailAddress != null ? a.emailAddress.toString() : "";
                b = b.emailAddress != null ? b.emailAddress.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return <a href={`mailto:${text}`}>{text}</a>
            },
        },

        {
            title: 'Delivery Date',
            dataIndex: 'deliveryDate',
            className: "width140",
            sorter: (a, b) => {
                a = a.deliveryDate != null ? a.deliveryDate.toString() : "";
                b = b.deliveryDate != null ? b.deliveryDate.toString() : "";
                return a.localeCompare(b);
            },
        },

        {
            title: 'No. of Devices',
            dataIndex: 'deviceCount',
            className: "width100 textCenter",
            sorter: (a, b) => {
                a = a.deviceCount != null ? a.deviceCount.toString() : "";
                b = b.deviceCount != null ? b.deviceCount.toString() : "";
                return a.localeCompare(b);
            },
        },
                {
            title: 'Referring Organization',
            dataIndex: 'refOrganization',
            className: "width100 textCenter",
            sorter: (a, b) => {
                a = a.refOrganization != null ? a.refOrganization.toString() : "";
                b = b.refOrganization != null ? b.refOrganization.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Apply For',
            dataIndex: 'applyFor',
            className: "width100 textCenter",
            sorter: (a, b) => {
                a = a.applyFor != null ? a.applyFor.toString() : "";
                b = b.applyFor != null ? b.applyFor.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Action',
            dataIndex: 'floridaAction',
            className: "width140 textCenter",

        },


    ],

    AgencyList: [
        {
            title: 'Agency Name',
            dataIndex: 'agencyName',
            className: "width140",
            sorter: (a, b) => {
                a = a.agencyName != null ? a.agencyName.toString() : "";
                b = b.agencyName != null ? b.agencyName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Email Address',
            dataIndex: 'email',
            className: "width140",
            sorter: (a, b) => {
                a = a.email != null ? a.email.toString() : "";
                b = b.email != null ? b.email.toString() : "";
                return a.localeCompare(b);
            },
        },

        {
            title: 'Phone #',
            dataIndex: 'phone',
            className: "width140",
            sorter: (a, b) => {
                a = a.phone != null ? a.phone.toString() : "";
                b = b.phone != null ? b.phone.toString() : "";
                return a.localeCompare(b);
            },
            render: text => {
                return formateMdnNumber(text);
            }
        },
        {
            title: 'Contact Person',
            dataIndex: 'contactPerson',
            className: "width140",
            sorter: (a, b) => {
                a = a.contactPerson != null ? a.contactPerson.toString() : "";
                b = b.contactPerson != null ? b.contactPerson.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Region/City',
            dataIndex: 'region',
            className: "width140",
            sorter: (a, b) => {
                a = a.region != null ? a.region.toString() : "";
                b = b.region != null ? b.region.toString() : "";
                return a.localeCompare(b);
            },
        },

        {
            title: 'Actions',
            dataIndex: 'commonAction',
            className: "commonActionWidth70",
        },
    ],

    LosAgencyList: [
        {
            title: 'Name',
            dataIndex: 'agencyName',
            className: "width140",
            sorter: (a, b) => {
                a = a.agencyName != null ? a.agencyName.toString() : "";
                b = b.agencyName != null ? b.agencyName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Type',
            dataIndex: 'agencyTypeName',
            className: "width140",
            sorter: (a, b) => {
                a = a.agencyType != null ? a.agencyType.toString() : "";
                b = b.agencyType != null ? b.agencyType.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Email Address',
            dataIndex: 'email',
            className: "width140",
            sorter: (a, b) => {
                a = a.email != null ? a.email.toString() : "";
                b = b.email != null ? b.email.toString() : "";
                return a.localeCompare(b);
            },
        },

        {
            title: 'Phone #',
            dataIndex: 'phone',
            className: "width80",
            sorter: (a, b) => {
                a = a.phone != null ? a.phone.toString() : "";
                b = b.phone != null ? b.phone.toString() : "";
                return a.localeCompare(b);
            },
            render: text => {
                return formateMdnNumber(text);
            }
        },

        {
            title: 'Actions',
            dataIndex: 'commonAction',
            className: "commonActionWidth70",
        },
    ],

    AgencyListForDistributer: [
        {
            title: '',
            dataIndex: 'agencyId',
            className: "custom-grid-hide-col"
        },
        {
            title: 'Agency Name',
            dataIndex: 'agencyName',
            className: "width140",
            sorter: (a, b) => {
                a = a.agencyName != null ? a.agencyName.toString() : "";
                b = b.agencyName != null ? b.agencyName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Email Address',
            dataIndex: 'email',
            className: "width140",
            sorter: (a, b) => {
                a = a.email != null ? a.email.toString() : "";
                b = b.email != null ? b.email.toString() : "";
                return a.localeCompare(b);
            },
        },

        {
            title: 'Phone #',
            dataIndex: 'phone',
            className: "width140",
            sorter: (a, b) => {
                a = a.phone != null ? a.phone.toString() : "";
                b = b.phone != null ? b.phone.toString() : "";
                return a.localeCompare(b);
            },
            render: text => {
                return formateMdnNumber(text);
            }
        },
        {
            title: 'Contact Person',
            dataIndex: 'contactPerson',
            className: "width140",
            sorter: (a, b) => {
                a = a.contactPerson != null ? a.contactPerson.toString() : "";
                b = b.contactPerson != null ? b.contactPerson.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Date/Time',
            dataIndex: 'createDate',
            className: "width140",
            sorter: (a, b) => {
                a = a.createDate != null ? a.createDate.toString() : "";
                b = b.createDate != null ? b.createDate.toString() : "";
                return a.localeCompare(b);
            },
            render: text => {
                return formatDateTime(text);
            }
        },
    ],

    LOSAgencyDocumentList: [
        {
            title: 'Agency Name',
            dataIndex: 'agencyName',
            sorter: (a, b) => {
                a = a.agencyName != null ? a.agencyName.toString() : "";
                b = b.agencyName != null ? b.agencyName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Agency Type',
            dataIndex: 'agencyType',
            sorter: (a, b) => {
                a = a.agencyType != null ? a.agencyType.toString() : "";
                b = b.agencyType != null ? b.agencyType.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Letter Of Support',
            dataIndex: 'openDocument',
            sorter: (a, b) => {
                a = a.openDocument != null ? a.openDocument.toString() : "";
                b = b.openDocument != null ? b.openDocument.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Receiving Date',
            dataIndex: 'createDate',
            sorter: (a, b) => {
                a = a.createDate != null ? a.createDate.toString() : "";
                b = b.createDate != null ? b.createDate.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Actions',
            dataIndex: 'commonAction',
            className: "width80 textCenter",
        },
    ],

    LosAgencyListForDistributer: [
        {
            title: '',
            dataIndex: 'agencyId',
            className: "custom-grid-hide-col"
        },
        {
            title: 'Agency Name',
            dataIndex: 'agencyName',
            className: "width140",
            sorter: (a, b) => {
                a = a.agencyName != null ? a.agencyName.toString() : "";
                b = b.agencyName != null ? b.agencyName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Agency Type',
            dataIndex: 'agencyTypeName',
            className: "width140",
            sorter: (a, b) => {
                a = a.agencyTypeName != null ? a.agencyTypeName.toString() : "";
                b = b.agencyTypeName != null ? b.agencyTypeName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Email Address',
            dataIndex: 'email',
            className: "width140",
            sorter: (a, b) => {
                a = a.email != null ? a.email.toString() : "";
                b = b.email != null ? b.email.toString() : "";
                return a.localeCompare(b);
            },
        },

        {
            title: 'Phone #',
            dataIndex: 'phone',
            className: "width140",
            sorter: (a, b) => {
                a = a.phone != null ? a.phone.toString() : "";
                b = b.phone != null ? b.phone.toString() : "";
                return a.localeCompare(b);
            },
            render: text => {
                return formateMdnNumber(text);
            }
        },
    ],

    DistributerList: [
        {
            title: 'List Name',
            dataIndex: 'listName',
            className: "width80",
            sorter: (a, b) => {
                a = a.listName != null ? a.listName.toString() : "";
                b = b.listName != null ? b.listName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Description',
            dataIndex: 'shortDescription',
            className: "width140",
            sorter: (a, b) => {
                a = a.shortDescription != null ? a.shortDescription.toString() : "";
                b = b.shortDescription != null ? b.shortDescription.toString() : "";
                return a.localeCompare(b);
            },
        },


        {
            title: 'No of Agencies',
            dataIndex: 'agenciesCount',
            className: "width30",
            sorter: (a, b) => {
                a = a.agenciesCount != null ? a.agenciesCount.toString() : "";
                b = b.agenciesCount != null ? b.agenciesCount.toString() : "";
                return a.localeCompare(b);
            },
        },

        {
            title: 'Actions',
            dataIndex: 'commonAction',
            className: "commonActionWidth30",
        },
    ],

    PressRelease: [
        {
            title: <><EyeOutlined /></>,
            dataIndex: 'pressReleaseConfirmationCode',
            className: "width40",
        },
        {
            title: 'ID #',
            dataIndex: 'pressReleaseId',
            className: "width140",
            sorter: (a, b) => {
                a = a.pressReleaseId != null ? a.pressReleaseId.toString() : "";
                b = b.pressReleaseId != null ? b.pressReleaseId.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return <p>{"PL-" + text}</p>
            },
        },
        {
            title: 'Distribution List',
            dataIndex: 'distributionListName',
            className: "width140",
            sorter: (a, b) => {
                a = a.distributionListName != null ? a.distributionListName.toString() : "";
                b = b.distributionListName != null ? b.distributionListName.toString() : "";
                return a.localeCompare(b);
            },
        }, {
            title: 'Created By',
            dataIndex: 'createdByName',
            className: "width140",
            sorter: (a, b) => {
                a = a.createdByName != null ? a.createdByName.toString() : "";
                b = b.createdByName != null ? b.createdByName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Date/Time',
            dataIndex: 'createDate',
            className: "width140",
            sorter: (a, b) => {
                a = a.createDate != null ? a.createDate.toString() : "";
                b = b.createDate != null ? b.createDate.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Title',
            dataIndex: 'title',
            className: "width140",
            sorter: (a, b) => {
                a = a.title != null ? a.title.toString() : "";
                b = b.title != null ? b.title.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Email Open Rate',
            dataIndex: 'openRate',
            className: "width140",
            sorter: (a, b) => {
                a = a.openRate != null ? a.openRate.toString() : "";
                b = b.openRate != null ? b.openRate.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Scheduled Date/Time',
            dataIndex: 'scheduleDateTime',
            className: "width140",
            sorter: (a, b) => {
                a = a.scheduleDateTime != null ? a.scheduleDateTime.toString() : "";
                b = b.scheduleDateTime != null ? b.scheduleDateTime.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return formatDateTime(text);
            }
        },
        {
            title: 'Status',
            dataIndex: 'status',
            className: "width140",
            sorter: (a, b) => {
                a = a.status != null ? a.status.toString() : "";
                b = b.status != null ? b.status.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return <p style={{ color: (text == 'Published' ? 'green' : text == 'Scheduled' ? 'red' : '#e99b00'), margin: '0' }}> {text == 'Published' || text == 'Scheduled' ? text : text + '...'}</p>
            },
        },
        {
            title: 'Action',
            dataIndex: 'pressReleaseAction',
            className: "width140 textCenter",
        },

    ],

    LetterofSupportTab: [
        //{
        //    title: <><EyeOutlined /></>,
        //    dataIndex: 'letterOfSupportView',
        //    className: "width40",
        //},

        {
            title: 'ID #',
            dataIndex: 'letterOfSupportId',
            className: "width140",
            sorter: (a, b) => {
                a = a.letterOfSupportId != null ? a.letterOfSupportId.toString() : "";
                b = b.letterOfSupportId != null ? b.letterOfSupportId.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return <p>{"LOS-" + text}</p>
            },
        },
        {
            title: 'Distribution List',
            dataIndex: 'distributionListName',
            className: "width140",
            sorter: (a, b) => {
                a = a.distributionListName != null ? a.distributionListName.toString() : "";
                b = b.distributionListName != null ? b.distributionListName.toString() : "";
                return a.localeCompare(b);
            },
        }, {
            title: 'Created By',
            dataIndex: 'createdByName',
            className: "width140",
            sorter: (a, b) => {
                a = a.createdByName != null ? a.createdByName.toString() : "";
                b = b.createdByName != null ? b.createdByName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Date/Time',
            dataIndex: 'createDate',
            className: "width140",
            sorter: (a, b) => {
                a = a.createDate != null ? a.createDate.toString() : "";
                b = b.createDate != null ? b.createDate.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Title',
            dataIndex: 'title',
            className: "width140",
            sorter: (a, b) => {
                a = a.title != null ? a.title.toString() : "";
                b = b.title != null ? b.title.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Subject',
            dataIndex: 'subject',
            className: "width140",
            sorter: (a, b) => {
                a = a.subject != null ? a.subject.toString() : "";
                b = b.subject != null ? b.subject.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Email Open Rate',
            dataIndex: 'openRate',
            className: "width140",
            sorter: (a, b) => {
                a = a.openRate != null ? a.openRate.toString() : "";
                b = b.openRate != null ? b.openRate.toString() : "";
                return a.localeCompare(b);
            },
        },

        {
            title: 'Status',
            dataIndex: 'status',
            className: "width140",
            sorter: (a, b) => {
                a = a.status != null ? a.status.toString() : "";
                b = b.status != null ? b.status.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return <p style={{ color: (text == 'Sent' ? 'green' : text == 'Scheduled' ? 'red' : text == 'Draft' ? 'rgb(0 0 0 / 85%)' : '#e99b00'), margin: '0' }}> {text == 'Sent' || text == 'Scheduled' || text == 'Draft' ? text : text + '...'}</p>
            },
        },
        {
            title: 'Action',
            dataIndex: 'letterOfSupportAction',
            className: "width140 textCenter",
        },

    ],

    ReceivedGrants: [
        {
            title: 'Program Name',
            dataIndex: 'programName',
            className: "width140",
            sorter: (a, b) => {
                a = a.listName != null ? a.listName.toString() : "";
                b = b.listName != null ? b.listName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Grant Amount',
            dataIndex: 'grantAmount',
            className: "width140",
            sorter: (a, b) => {
                a = a.paidAmount != null ? a.paidAmount.toString() : "";
                b = b.paidAmount != null ? b.paidAmount.toString() : "";
                return a.localeCompare(b);
            },
            render: (text, record) => formatCurrency(record.grantAmount),
        },

        {
            title: 'Disbursed Amount',
            dataIndex: 'disbursedAmount',
            className: 'width140 ColorGreen',
            sorter: (a, b) => {
                a = a.fullName != null ? a.fullName.toString() : '';
                b = b.fullName != null ? b.fullName.toString() : '';
                return a.localeCompare(b);
            },
            render: (text, record) => formatCurrency(record.disbursedAmount),
        },
        {
            title: 'Unallocated',
            dataIndex: 'Unallocated',
            key: 'PendingRejected',
            className: 'width140 ColorRed',
            sorter: (a, b) => {
                a = a.fullName != null ? a.fullName.toString() : "";
                b = b.fullName != null ? b.fullName.toString() : "";
                return a.localeCompare(b);
            },
            render: (text, record) => formatCurrency(record.Unallocated),
            // render: (text, record) => {
            //   if (record.RejectedStatus === 1) {
            //     return <Typography>{record.rejectedAmount}</Typography>;
            //   } else if (record.pendingStatus === 1) {
            //     return <Typography>{record.pendingAmount}</Typography>;
            //   }
            //   return null; // Default case or when neither rejected nor pending
            // },
        },
    ],



    ComplianceReports: [
        {
            title: 'Program Name',
            dataIndex: 'programName',
            className: "width140",
            sorter: (a, b) => {
                a = a.listName != null ? a.listName.toString() : "";
                b = b.listName != null ? b.listName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Disbursed Amount',
            dataIndex: 'disbursedAmount',
            className: "width140 ColorGreen",
            sorter: (a, b) => {
                a = a.paidAmount != null ? a.paidAmount.toString() : "";
                b = b.paidAmount != null ? b.paidAmount.toString() : "";
                return a.localeCompare(b);
            },
            render: (text, record) => formatCurrency(record.disbursedAmount),
        },
        {
            title: 'Actions ',
            dataIndex: 'Actiondownload',
            className: "width140 textCenter",
            sorter: (a, b) => {
                a = a.donationGridAction != null ? a.donationGridAction.toString() : "";
                b = b.donationGridAction != null ? b.donationGridAction.toString() : "";
                return a.localeCompare(b);
            },
        },
    ],

    EveryChildChristmas: [
        {
            title: '',
            dataIndex: 'applicationId',
            className: "custom-grid-hide-col"
        },
        {
            /*title: <><EyeOutlined /></>,*/
            dataIndex: 'confirmationCode',
            className: "width50",
        },
        {
            title: 'Application ID',
            dataIndex: 'applicationId',
            className: "width120 ",
            sorter: (a, b) => {
                a = a.applicationId != null ? a.applicationId.toString() : "";
                b = b.applicationId != null ? b.applicationId.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return `F-${text}`
            },
        },
        {
            title: 'Parent/Gaurdian Name',
            dataIndex: 'parentName',
            className: "",
            sorter: (a, b) => {
                a = a.parentName != null ? a.parentName.toString() : "";
                b = b.parentName != null ? b.parentName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'No. of Children',
            dataIndex: 'childCount',
            className: "",
            sorter: (a, b) => {
                a = a.childCount != null ? a.childCount.toString() : "";
                b = b.childCount != null ? b.childCount.toString() : "";
                return a.localeCompare(b);
            },

        },
        {
            title: 'Phone #',
            dataIndex: 'phone',
            className: "",
            sorter: (a, b) => {
                a = a.phone != null ? a.phone.toString() : "";
                b = b.phone != null ? b.phone.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return < a href={`tel:${phoneNumber(text)}`} > {text}</a>
            },

        },
        {
            title: 'Email',
            dataIndex: 'email',
            className: "",
            sorter: (a, b) => {
                a = a.email != null ? a.email.toString() : "";
                b = b.email != null ? b.email.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return <a href={`mailto:${text}`}>{text}</a>
            },
        },
        {
            title: 'Zip Code',
            dataIndex: 'zip',
            className: "",
            sorter: (a, b) => {
                a = a.zip != null ? a.zip.toString() : "";
                b = b.zip != null ? b.zip.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Status',
            dataIndex: 'applicationStatus',
            className: "width90",
            sorter: (a, b) => {
                a = a.applicationStatus != null ? a.applicationStatus.toString() : "";
                b = b.applicationStatus != null ? b.applicationStatus.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Action',
            dataIndex: 'christmasActions',
            className: "width230 textCenter",
            sorter: (a, b) => {
                a = a.action != null ? a.action.toString() : "";
                b = b.action != null ? b.action.toString() : "";
                return a.localeCompare(b);
            },
        },


    ],

    DonorGrantHistpry: [
        {
            title: 'Grant Date',
            dataIndex: 'createDate',
            className: "width140 textCenter",
            sorter: (a, b) => {
                a = a.createDate != null ? a.createDate.toString() : "";
                b = b.createDate != null ? b.createDate.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return formatDate(text);
            },
        },
        {
            title: 'Grant Amount',
            dataIndex: 'amountReceived',
            className: "width180 textCenter",
            sorter: (a, b) => {
                a = a.amountReceived != null ? a.amountReceived.toString() : "";
                b = b.amountReceived != null ? b.amountReceived.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => formatCurrency(text),
        },

        {
            title: 'Program Name',
            dataIndex: 'programName',
            className: 'width200 textCenter',
            sorter: (a, b) => {
                a = a.programName != null ? a.programName.toString() : '';
                b = b.programName != null ? b.programName.toString() : '';
                return a.localeCompare(b);
            },

        },
        {
            title: 'Payment Method',
            dataIndex: 'paymentMethod',
            className: "width180 ColorBlue textCenter",
            sorter: (a, b) => {
                a = a.paymentMethod != null ? a.paymentMethod.toString() : "";
                b = b.paymentMethod != null ? b.paymentMethod.toString() : "";
                return a.localeCompare(b);
            },
        },

        {
            title: 'Payment Reference',
            dataIndex: 'paymentReference',
            className: "ColorGreen textCenter",
            sorter: (a, b) => {
                a = a.paymentReference != null ? a.paymentReference.toString() : "";
                b = b.paymentReference != null ? b.paymentReference.toString() : "";
                return a.localeCompare(b);
            },

        },

        {
            title: 'Notes',
            dataIndex: 'collectionNotes',
            className: "textCenter",
            sorter: (a, b) => {
                a = a.collectionNotes != null ? a.collectionNotes.toString() : "";
                b = b.collectionNotes != null ? b.collectionNotes.toString() : "";
                return a.localeCompare(b);
            },
        }
    ],
    donor: [
        {
            title: 'Donor name',
            dataIndex: 'donorName',
            className: "width140",
            sorter: (a, b) => {
                a = a.donorName != null ? a.donorName.toString() : "";
                b = b.donorName != null ? b.donorName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Email',
            dataIndex: 'contactPersonEmail',
            className: "width140",
            sorter: (a, b) => {
                a = a.contactPersonEmail != null ? a.contactPersonEmail.toString() : "";
                b = b.contactPersonEmail != null ? b.contactPersonEmail.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Contact #',
            dataIndex: 'contactPersonPhone',
            className: "width140",
            sorter: (a, b) => {
                a = a.contactPersonPhone != null ? a.contactPersonPhone.toString() : "";
                b = b.contactPersonPhone != null ? b.contactPersonPhone.toString() : "";
                return a.localeCompare(b);
            },
        },

        {
            title: 'EIN',
            dataIndex: 'einSsnEncrypted',
            className: "width140",
            sorter: (a, b) => {
                a = a.einSsnEncrypted != null ? a.einSsnEncrypted.toString() : "";
                b = b.einSsnEncrypted != null ? b.einSsnEncrypted.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'State Tex ID',
            dataIndex: 'stateTaxNumber',
            className: "width140",
            sorter: (a, b) => {
                a = a.stateTaxNumber != null ? a.stateTaxNumber.toString() : "";
                b = b.stateTaxNumber != null ? b.stateTaxNumber.toString() : "";
                return a.localeCompare(b);
            },
        },
        // {
        //     title: 'Rating',
        //     dataIndex: 'rating',
        //     className: "width140",
        //     sorter: (a, b) => {
        //         a = a.notesHTML != null ? a.notesHTML.toString() : "";
        //         b = b.notesHTML != null ? b.notesHTML.toString() : "";
        //         return a.localeCompare(b);
        //     },
        // },
        {
            title: 'Actions',
            dataIndex: 'donorBtns',
            className: "commonActionWidth",
        },
    ],

    cashDisbursement: [

        {
            title: 'Organization Name',
            dataIndex: 'donorName',
            className: 'textCenter',
            sorter: (a, b) => {
                a = a.donorName != null ? a.donorName.toString() : '';
                b = b.donorName != null ? b.donorName.toString() : '';
                return a.localeCompare(b);
            },

        },
        {
            title: 'program Name',
            dataIndex: 'programName',
            className: "textCenter",
            sorter: (a, b) => {
                a = a.email != null ? a.email.toString() : "";
                b = b.email != null ? b.email.toString() : "";
                return a.localeCompare(b);
            },
        },
        // {
        //     title: 'promised Grant',
        //     dataIndex: 'promisedAmount',
        //     className: "textCenter",
        //     sorter: (a, b) => {
        //         a = a.promisedAmount != null ? a.promisedAmount.toString() : "";
        //         b = b.promisedAmount != null ? b.promisedAmount.toString() : "";
        //         return a.localeCompare(b);
        //     },
        //     render: (text, record) => formatCurrency(text),
        // },
        {
            title: 'disbursed Grant',
            dataIndex: 'disbursedAmount',
            className: "textCenter ColorGreen",
            sorter: (a, b) => {
                a = a.disbursedAmount != null ? a.disbursedAmount.toString() : "";
                b = b.disbursedAmount != null ? b.disbursedAmount.toString() : "";
                return a.localeCompare(b);
            },
            render: (text, record) => formatCurrency(text),
        },

        {
            title: 'Purpose',
            dataIndex: 'disbursementNotes',
            className: "textCenter width140",
            sorter: (a, b) => {
                a = a.disbursementNotes != null ? a.disbursementNotes.toString() : "";
                b = b.disbursementNotes != null ? b.disbursementNotes.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Disburse Date',
            dataIndex: 'createDate',
            className: "textCenter",
            sorter: (a, b) => {
                a = a.createDate != null ? a.createDate.toString() : "";
                b = b.createDate != null ? b.createDate.toString() : "";
                return a.localeCompare(b);
            },
            render: (text, record) => (
                <>
                    {formatDate(text)}
                </>
            ),
        },

        {
            title: 'Action',
            dataIndex: 'cashDisbursement',
            className: "textCenter",
        },
    ],

    inKindDisbursementDetails: [

        {
            title: 'Date',
            dataIndex: 'createDate',
            className: 'textCenter width180',
            sorter: (a, b) => {
                a = a.createDate != null ? a.createDate.toString() : '';
                b = b.createDate != null ? b.createDate.toString() : '';
                return a.localeCompare(b);
            }, render: (text, record) => (
                <>
                    {formatDate(text)}
                </>
            ),

        },
        {
            title: 'Item Name',
            dataIndex: 'itemName',
            className: "width140 textCenter",
            sorter: (a, b) => {
                a = a.itemName != null ? a.itemName.toString() : "";
                b = b.itemName != null ? b.itemName.toString() : "";
                return a.localeCompare(b);
            },
        },

        {
            title: 'Qty',
            dataIndex: 'qty',
            className: "width140 textCenter ColorGreen",
            sorter: (a, b) => {
                a = a.qty != null ? a.qty.toString() : "";
                b = b.qty != null ? b.qty.toString() : "";
                return a.localeCompare(b);
            },
        },

        {
            title: 'Status',
            dataIndex: 'status',
            className: "width140 textCenter",
            sorter: (a, b) => {
                a = a.status != null ? a.status.toString() : "";
                b = b.status != null ? b.status.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => (
                <>
                    {text == null ? 'pending' : text}
                </>
            ),
        },

        {
            title: 'Date',
            dataIndex: 'disbursedDate',
            className: "width140 textCenter",
            sorter: (a, b) => {
                a = a.disbursedDate != null ? a.disbursedDate.toString() : "";
                b = b.disbursedDate != null ? b.disbursedDate.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return formatDate(text);
            },
        }

    ],



    cashDisbursementDetails: [

        {
            title: 'Organization Name',
            dataIndex: 'donorName',
            className: 'textCenter',
            sorter: (a, b) => {
                a = a.donorName != null ? a.donorName.toString() : '';
                b = b.donorName != null ? b.donorName.toString() : '';
                return a.localeCompare(b);
            },

        },
        {
            title: 'program Name',
            dataIndex: 'programName',
            className: "textCenter",
            sorter: (a, b) => {
                a = a.email != null ? a.email.toString() : "";
                b = b.email != null ? b.email.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'promised Grant',
            dataIndex: 'promisedAmount',
            className: "textCenter",
            sorter: (a, b) => {
                a = a.promisedAmount != null ? a.promisedAmount.toString() : "";
                b = b.promisedAmount != null ? b.promisedAmount.toString() : "";
                return a.localeCompare(b);
            },
            render: (text, record) => formatCurrency(text),
        },

        {
            title: 'Purpose',
            dataIndex: 'disbursementNotes',
            className: "textCenter",
            sorter: (a, b) => {
                a = a.disbursementNotes != null ? a.disbursementNotes.toString() : "";
                b = b.disbursementNotes != null ? b.disbursementNotes.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Disburse Date',
            dataIndex: 'createDate',
            className: "textCenter",
            sorter: (a, b) => {
                a = a.createDate != null ? a.createDate.toString() : "";
                b = b.createDate != null ? b.createDate.toString() : "";
                return a.localeCompare(b);
            },
            render: (text, record) => (
                <>
                    {formatDate(text)}
                </>
            ),
        },


    ],

    inKindDisbursement: [

        {
            title: 'Organization Name',
            dataIndex: 'donorName',
            className: 'width180',
            sorter: (a, b) => {
                a = a.donorName != null ? a.donorName.toString() : '';
                b = b.donorName != null ? b.donorName.toString() : '';
                return a.localeCompare(b);
            },

        },
        {
            title: 'program Name',
            dataIndex: 'programName',
            className: "",
            sorter: (a, b) => {
                a = a.programName != null ? a.programName.toString() : "";
                b = b.programName != null ? b.programName.toString() : "";
                return a.localeCompare(b);
            },
        },


        {
            title: 'Approved Qty',
            dataIndex: 'disbursedQty',
            className: "textCenter ColorGreen",
            sorter: (a, b) => {
                a = a.paidAmount != null ? a.paidAmount.toString() : "";
                b = b.paidAmount != null ? b.paidAmount.toString() : "";
                return a.localeCompare(b);
            },
        },

        {
            title: 'Disbursement Notes',
            dataIndex: 'inKindDisbursementNotes',
            className: "textCenter",
            sorter: (a, b) => {
                a = a.inKindDisbursementNotes != null ? a.inKindDisbursementNotes.toString() : "";
                b = b.inKindDisbursementNotes != null ? b.inKindDisbursementNotes.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Date',
            dataIndex: 'disbursedDate',
            className: "textCenter",
            sorter: (a, b) => {
                a = a.disbursedDate != null ? a.disbursedDate.toString() : "";
                b = b.disbursedDate != null ? b.disbursedDate.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return formatDate(text);
            },
        },
        {
            title: 'Action',
            dataIndex: 'cashDisbursement',
            className: "textCenter",
        },

    ],

    GranteeDetail: [
        {
            title: 'Received Date',
            dataIndex: 'installmentDate',
            className: "textCenter",
            sorter: (a, b) => {
                a = a.installmentDate != null ? a.installmentDate.toString() : "";
                b = b.installmentDate != null ? b.installmentDate.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return formatDate(text);
            },
        },
        {
            title: 'Installment Amount',
            dataIndex: 'amountReceived',
            className: "textCenter",
            sorter: (a, b) => {
                a = a.installmentAmount != null ? a.installmentAmount.toString() : "";
                b = b.installmentAmount != null ? b.installmentAmount.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => formatCurrency(text),
        },
        {
            title: 'Payment Method',
            dataIndex: 'paymentMethod',
            className: "ColorBlue textCenter",
            sorter: (a, b) => {
                a = a.paymentMethod != null ? a.paymentMethod.toString() : "";
                b = b.paymentMethod != null ? b.paymentMethod.toString() : "";
                return a.localeCompare(b);
            },
        },

        {
            title: 'Payment Reference',
            dataIndex: 'paymentReference',
            className: "textCenter ColorGreen",
            sorter: (a, b) => {
                a = a.paymentReference != null ? a.paymentReference.toString() : "";
                b = b.paymentReference != null ? b.paymentReference.toString() : "";
                return a.localeCompare(b);
            },

        },

        {
            title: 'Attachment',
            dataIndex: 'attachmentFilePath',
            className: "textCenter",
            sorter: (a, b) => {
                a = a.attachmentFilePath != null ? a.attachmentFilePath.toString() : "";
                b = b.attachmentFilePath != null ? b.attachmentFilePath.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return <a href={text} target="_target">Download</a>
            },

        }
    ],

    GrantReceived: [
        {
            title: 'Received Date',
            dataIndex: 'createDate',
            className: "textCenter",
            sorter: (a, b) => {
                a = a.createDate != null ? a.createDate.toString() : "";
                b = b.createDate != null ? b.createDate.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return formatDate(text);
            },
        },
        {
            title: 'Amount',
            dataIndex: 'amountReceived',
            className: "textCenter",
            sorter: (a, b) => {
                a = a.installmentAmount != null ? a.installmentAmount.toString() : "";
                b = b.installmentAmount != null ? b.installmentAmount.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => formatCurrency(text),
        },
        {
            title: 'Payment Method',
            dataIndex: 'paymentMethod',
            className: "ColorBlue textCenter",
            sorter: (a, b) => {
                a = a.paymentMethod != null ? a.paymentMethod.toString() : "";
                b = b.paymentMethod != null ? b.paymentMethod.toString() : "";
                return a.localeCompare(b);
            },
        },

        {
            title: 'Payment Reference',
            dataIndex: 'paymentReference',
            className: "textCenter ColorGreen",
            sorter: (a, b) => {
                a = a.paymentReference != null ? a.paymentReference.toString() : "";
                b = b.paymentReference != null ? b.paymentReference.toString() : "";
                return a.localeCompare(b);
            },

        },

        {
            title: 'Attachment',
            dataIndex: 'attachmentFilePath',
            className: "textCenter",
            sorter: (a, b) => {
                a = a.attachmentFilePath != null ? a.attachmentFilePath.toString() : "";
                b = b.attachmentFilePath != null ? b.attachmentFilePath.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return <a href={text} target="_target">Download</a>
            },

        }
    ],
    Subscribers: [
        {
            title: '',
            dataIndex: 'subscriberId',
            className: "custom-grid-hide-col"
        },
        {
            title: 'Name',
            dataIndex: 'fullName',
            className: "",
            sorter: (a, b) => {
                a = a.fullName != null ? a.fullName.toString() : "";
                b = b.fullName != null ? b.fullName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Email',
            dataIndex: 'email',
            className: "",
            sorter: (a, b) => {
                a = a.email != null ? a.email.toString() : "";
                b = b.email != null ? b.email.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return <a href={`mailto:${text}`}>{text}</a>
            },
        },
        {
            title: 'Phone #',
            dataIndex: 'phone',
            className: "width230",
            sorter: (a, b) => {
                a = a.phone != null ? a.phone.toString() : "";
                b = b.phone != null ? b.phone.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return < a href={`tel:${phoneNumber(text)}`} > {text}</a>
            },

        },

        {
            title: 'Date',
            dataIndex: 'updateDate',
            className: "width230",
            sorter: (a, b) => {
                a = a.updateDate != null ? a.updateDate.toString() : "";
                b = b.updateDate != null ? b.updateDate.toString() : "";
                return a.localeCompare(b);
            },
            //render: (text) => {
            //    return formatDateTime(text);
            //},

        },
        {
            title: 'Status',
            dataIndex: 'status',
            className: "width150",
            sorter: (a, b) => {
                a = a.status != null ? a.status.toString() : "";
                b = b.status != null ? b.status.toString() : "";
                return a.localeCompare(b);
            },
        },
        //{
        //    title: 'Action',
        //    dataIndex: 'christmasActions',
        //    className: "width230 textCenter",
        //    sorter: (a, b) => {
        //        a = a.action != null ? a.action.toString() : "";
        //        b = b.action != null ? b.action.toString() : "";
        //        return a.localeCompare(b);
        //    },
        //},


    ],
    roles: [
        {
            title: 'Role Name',
            dataIndex: 'roleName',
            className: "width180",
            sorter: (a, b) => {
                a = a.roleName != null ? a.roleName.toString() : "";
                b = b.roleName != null ? b.roleName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Description',
            dataIndex: 'roleDescription',
            className: "width230",
            sorter: (a, b) => {
                a = a.roleDescription != null ? a.roleDescription.toString() : "";
                b = b.roleDescription != null ? b.roleDescription.toString() : "";
                return a.localeCompare(b);
            },
        },
        //{
        //    title: 'Type',
        //    dataIndex: 'roleType',
        //    className: "width140",
        //    sorter: (a, b) => {
        //        a = a.roleType != null ? a.roleType.toString() : "";
        //        b = b.roleType != null ? b.roleType.toString() : "";
        //        return a.localeCompare(b);
        //    },
        //},
        {
            title: 'Date',
            dataIndex: 'createDate',
            className: "width90",
            sorter: (a, b) => {
                a = a.createDate != null ? a.createDate.toString() : "";
                b = b.createDate != null ? b.createDate.toString() : "";
                return a.localeCompare(b);
            },
            render: text => {
                return formatDateTime(text);
            }
        },
        {
            //title: 'Actions',
            //dataIndex: 'commonAction',
            //className: "commonActionWidth",
            title: 'Actions',
            dataIndex: 'rolesAction',
            className: "commonActionWidth70",
        },
    ],
    users: [
        {
            title: 'Name',
            dataIndex: 'fullName',
            className: "width140",
            sorter: (a, b) => {
                a = a.fullName != null ? a.fullName.toString() : "";
                b = b.fullName != null ? b.fullName.toString() : "";
                return a.localeCompare(b);
            },

        },
        {
            title: 'Email',
            dataIndex: 'emailAddress',
            className: "width140",
            sorter: (a, b) => {
                a = a.emailAddress != null ? a.emailAddress.toString() : "";
                b = b.emailAddress != null ? b.emailAddress.toString() : "";
                return a.localeCompare(b);
            },
        },
        //{
        //    title: 'Phone',
        //    dataIndex: 'phoneNumber',
        //    className: "width140",
        //    sorter: (a, b) => {
        //        a = a.phoneNumber != null ? a.phoneNumber.toString() : "";
        //        b = b.phoneNumber != null ? b.phoneNumber.toString() : "";
        //        return a.localeCompare(b);
        //    },
        //},
        {
            title: 'Role',
            dataIndex: 'roleName',
            className: "width140",
            sorter: (a, b) => {
                a = a.roleName != null ? a.roleName.toString() : "";
                b = b.roleName != null ? b.roleName.toString() : "";
                return a.localeCompare(b);
            },
        },
        //{
        //    title: 'Address',
        //    dataIndex: 'completeAddress',
        //    className: "width140",
        //    sorter: (a, b) => {
        //        a = a.completeAddress != null ? a.completeAddress.toString() : "";
        //        b = b.completeAddress != null ? b.completeAddress.toString() : "";
        //        return a.localeCompare(b);
        //    },
        //},
        {
            title: 'Date',
            dataIndex: 'createDate',
            className: "width90",
            sorter: (a, b) => {
                a = a.createDate != null ? a.createDate.toString() : "";
                b = b.createDate != null ? b.createDate.toString() : "";
                return a.localeCompare(b);
            },
            render: text => {
                return formatDateTime(text);
            }
        },
        {
            title: 'Actions',
            dataIndex: 'commonAction',
            className: "commonActionWidth70",

        },
    ],
    socialWorker: [
        {
            title: 'Full Name',
            dataIndex: 'fullName',
            className: "width100",
            sorter: (a, b) => {
                a = a.fullName != null ? a.fullName.toString() : "";
                b = b.fullName != null ? b.fullName.toString() : "";
                return a.localeCompare(b);
            },

        },
        {
            title: 'SSN',
            dataIndex: 'ssn',
            className: "width40",
            sorter: (a, b) => {
                a = a.ssn != null ? a.ssn.toString() : "";
                b = b.ssn != null ? b.ssn.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Email Address',
            dataIndex: 'email',
            className: "width100",
            sorter: (a, b) => {
                a = a.email != null ? a.email.toString() : "";
                b = b.email != null ? b.email.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Phone #',
            dataIndex: 'phone',
            className: "width80",
            sorter: (a, b) => {
                a = a.phone != null ? a.phone.toString() : "";
                b = b.phone != null ? b.phone.toString() : "";
                return a.localeCompare(b);
            },
            render: text => {
                return formateMdnNumber(text);
            }
        },
        {
            title: 'Agency Name',
            dataIndex: 'agencyName',
            className: "width100",
            sorter: (a, b) => {
                a = a.agencyName != null ? a.agencyName.toString() : "";
                b = b.agencyName != null ? b.agencyName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'License #',
            dataIndex: 'agencyLicense',
            className: "width100",
            sorter: (a, b) => {
                a = a.AgencyLicense != null ? a.AgencyLicense.toString() : "";
                b = b.AgencyLicense != null ? b.AgencyLicense.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Status',
            dataIndex: 'status',
            className: "width50",
            sorter: (a, b) => {
                a = a.status != null ? a.status.toString() : "";
                b = b.status != null ? b.status.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Actions',
            dataIndex: 'socialWorkerAction',
            className: "commonActionWidth70",

        },
    ],
    blogs: [
        {
            title: 'Title',
            dataIndex: 'title',
            className: "width200",
            sorter: (a, b) => {
                a = a.title != null ? a.title.toString() : "";
                b = b.title != null ? b.title.toString() : "";
                return a.localeCompare(b);
            },
        },
        //{
        //    title: 'Status',
        //    dataIndex: 'status',
        //    className: "width80",
        //    sorter: (a, b) => {
        //        a = a.status != null ? a.status.toString() : "";
        //        b = b.status != null ? b.status.toString() : "";
        //        return a.localeCompare(b);
        //    },
        //},
        {
            title: 'Type',
            dataIndex: 'type',
            className: "width50",
            sorter: (a, b) => {
                a = a.modifiedBy != null ? a.modifiedBy.toString() : "";
                b = b.modifiedBy != null ? b.modifiedBy.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Published Date',
            dataIndex: 'publishedDate',
            className: "width50",
            sorter: (a, b) => {
                a = a.publishedDate != null ? a.publishedDate.toString() : "";
                b = b.publishedDate != null ? b.publishedDate.toString() : "";
                return a.localeCompare(b);
            },
            render: text => {
                return formatDate(text);
            }
        },

        {
            title: 'Actions',
            dataIndex: 'commonAction',
            className: "commonActionWidth50",
        },
    ],


    customerRights: [
        {
            title: 'Right Name',
            dataIndex: 'rightName',
            className: "width200",
            sorter: (a, b) => {
                a = a.rightName != null ? a.rightName.toString() : "";
                b = b.rightName != null ? b.rightName.toString() : "";
                return a.localeCompare(b);
            },
        },

        {
            title: 'Right Label',
            dataIndex: 'rightLabel',
            className: "width200",
            sorter: (a, b) => {
                a = a.rightLabel != null ? a.rightLabel.toString() : "";
                b = b.rightLabel != null ? b.rightLabel.toString() : "";
                return a.localeCompare(b);
            },
            // render: text => {
            //     return formatDate(text);
            // }
        },
        {
            title: 'Right Description',
            dataIndex: 'rightDescription',
            className: "width200",
            sorter: (a, b) => {
                a = a.rightDescription != null ? a.rightDescription.toString() : "";
                b = b.rightDescription != null ? b.rightDescription.toString() : "";
                return a.localeCompare(b);
            },
            // render: text => {
            //     return formatDate(text);
            // }
        },
        {
            title: 'Sort Order',
            dataIndex: 'sortOrder',
            className: "width120",
            sorter: (a, b) => {
                a = a.sortOrder != null ? a.sortOrder.toString() : "";
                b = b.sortOrder != null ? b.sortOrder.toString() : "";
                return a.localeCompare(b);
            },
            // render: text => {
            //     return formatDate(text);
            // }
        },

        {
            title: 'Role Type',
            dataIndex: 'roleType',
            className: "width120",
            sorter: (a, b) => {
                a = a.roleType != null ? a.roleType.toString() : "";
                b = b.roleType != null ? b.roleType.toString() : "";
                return a.localeCompare(b);
            },

            render: text => {
                return text == 'customer_portal' ? 'Customer Portal' : 'Service Portal'
            },
        },

        {
            title: 'Action',
            dataIndex: 'customerRights',
            className: "width140 textCenter",
        },

    ],

    feedingFamily: [

        {
            title: 'Proof of identity',
            dataIndex: 'identity_Proof',
            className: "width140 textCenter",
        },

        {
            title: 'Full Name',
            dataIndex: 'full_Name',
            className: "width120 textCenter",
            sorter: (a, b) => {
                a = a.full_Name != null ? a.full_Name.toString() : "";
                b = b.full_Name != null ? b.full_Name.toString() : "";
                return a.localeCompare(b);
            },
        },

        {
            title: 'Email',
            dataIndex: 'email',
            className: "width200 textCenter",
            sorter: (a, b) => {
                a = a.email != null ? a.email.toString() : "";
                b = b.email != null ? b.email.toString() : "";
                return a.localeCompare(b);
            },
            // render: text => {
            //     return formatDate(text);
            // }
        },
        {
            title: 'Phone',
            dataIndex: 'phone',
            className: "width150 textCenter",
            sorter: (a, b) => {
                a = a.phone != null ? a.phone.toString() : "";
                b = b.phone != null ? b.phone.toString() : "";
                return a.localeCompare(b);
            },
            // render: text => {
            //     return formatDate(text);
            // }
        },
        {
            title: 'Household Income',
            dataIndex: 'house_Hold_Income',
            className: "width180 textCenter",
            sorter: (a, b) => {
                a = a.house_Hold_Income != null ? a.house_Hold_Income.toString() : "";
                b = b.house_Hold_Income != null ? b.house_Hold_Income.toString() : "";
                return a.localeCompare(b);
            },
            render: text => {
                return formatNumberWithCommas(text)
            }
        },
        {
            title: 'Number Of Member',
            dataIndex: 'number_Of_Member',
            className: "width180 textCenter",
            sorter: (a, b) => {
                a = a.number_Of_Member != null ? a.number_Of_Member.toString() : "";
                b = b.number_Of_Member != null ? b.number_Of_Member.toString() : "";
                return a.localeCompare(b);
            }
        },

        {
            title: 'Zip Code',
            dataIndex: 'zip_Code',
            className: "width120 textCenter",
            sorter: (a, b) => {
                a = a.zip_Code != null ? a.zip_Code.toString() : "";
                b = b.zip_Code != null ? b.zip_Code.toString() : "";
                return a.localeCompare(b);
            }
        },



    ],
    FloridaConnectRepRequests: [
        {
            dataIndex: 'healthCareTabletConfirmation',
            className: "width10",
        },
        {
            title: 'Application ID',
            dataIndex: 'formatedApplicationId',
            className: "width100 ",
            sorter: (a, b) => {
                a = a.formatedApplicationId != null ? a.formatedApplicationId.toString() : "";
                b = b.formatedApplicationId != null ? b.formatedApplicationId.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Name',
            dataIndex: 'fullName',
            className: "width130",
            sorter: (a, b) => {
                a = a.fullName != null ? a.fullName.toString() : "";
                b = b.fullName != null ? b.fullName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Email',
            dataIndex: 'emailAddress',
            className: "width140",
            sorter: (a, b) => {
                a = a.emailAddress != null ? a.emailAddress.toString() : "";
                b = b.emailAddress != null ? b.emailAddress.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return <a href={`mailto:${text}`}>{text}</a>
            },
        },

        {
            title: 'Zip Code',
            dataIndex: 'zipCode',
            className: "width120",
            sorter: (a, b) => {
                a = a.zipCode != null ? a.zipCode.toString() : "";
                b = b.zipCode != null ? b.zipCode.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return < a href={`tel:${phoneNumber(text)}`} > {text}</a>
            },

        },
        {
            title: 'Phone #',
            dataIndex: 'formatedPhone',
            className: "width120",
            sorter: (a, b) => {
                a = a.formatedPhone != null ? a.formatedPhone.toString() : "";
                b = b.formatedPhone != null ? b.formatedPhone.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return < a href={`tel:${phoneNumber(text)}`} > {text}</a>
            },

        },
        {
            title: 'Pickup Date/Time',
            dataIndex: 'pickupDateTime',
            className: "width120",
            sorter: (a, b) => {
                a = a.pickupDateTime != null ? a.pickupDateTime.toString() : "";
                b = b.pickupDateTime != null ? b.pickupDateTime.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return formatDateTime(text);
            }
        },
        {
            title: 'No. of Devices',
            dataIndex: 'deviceCount',
            className: "width120",
            sorter: (a, b) => {
                a = a.deviceCount != null ? a.deviceCount.toString() : "";
                b = b.deviceCount != null ? b.deviceCount.toString() : "";
                return a.localeCompare(b);
            },
        },

        {
            title: 'Action',
            dataIndex: 'RepRequestsAction',
            className: "width140 textCenter",
        },


    ],
    FloridaConnectRepRejected: [
        {
            title: 'Application ID',
            dataIndex: 'formatedApplicationId',
            className: "width100 ",
            sorter: (a, b) => {
                a = a.formatedApplicationId != null ? a.formatedApplicationId.toString() : "";
                b = b.formatedApplicationId != null ? b.formatedApplicationId.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Name',
            dataIndex: 'fullName',
            className: "width140",
            sorter: (a, b) => {
                a = a.fullName != null ? a.fullName.toString() : "";
                b = b.fullName != null ? b.fullName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Email',
            dataIndex: 'emailAddress',
            className: "width140",
            sorter: (a, b) => {
                a = a.emailAddress != null ? a.emailAddress.toString() : "";
                b = b.emailAddress != null ? b.emailAddress.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return <a href={`mailto:${text}`}>{text}</a>
            },
        },
        {
            title: 'Zip Code',
            dataIndex: 'zipCode',
            className: "width120",
            sorter: (a, b) => {
                a = a.zipCode != null ? a.zipCode.toString() : "";
                b = b.zipCode != null ? b.zipCode.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return < a href={`tel:${phoneNumber(text)}`} > {text}</a>
            },

        },
        {
            title: 'Phone #',
            dataIndex: 'formatedPhone',
            className: "width80",
            sorter: (a, b) => {
                a = a.formatedPhone != null ? a.formatedPhone.toString() : "";
                b = b.formatedPhone != null ? b.formatedPhone.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return < a href={`tel:${phoneNumber(text)}`} > {text}</a>
            },

        },


        {
            title: 'Rejected By',
            dataIndex: 'rejectedByName',
            className: "width100",
            sorter: (a, b) => {
                a = a.rejectedByName != null ? a.rejectedByName.toString() : "";
                b = b.rejectedByName != null ? b.rejectedByName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Rejected Date',
            dataIndex: 'rejectedDate',
            className: "width120",
            sorter: (a, b) => {
                a = a.rejectedDate != null ? a.rejectedDate.toString() : "";
                b = b.rejectedDate != null ? b.rejectedDate.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Action',
            dataIndex: 'RepRequestsAction',
            className: "width140 textCenter",

        },


    ],
    FloridaConnectRepDelivered: [
        {
            title: 'Application ID',
            dataIndex: 'formatedApplicationId',
            className: "width100 ",
            sorter: (a, b) => {
                a = a.formatedApplicationId != null ? a.formatedApplicationId.toString() : "";
                b = b.formatedApplicationId != null ? b.formatedApplicationId.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Name',
            dataIndex: 'fullName',
            className: "width140",
            sorter: (a, b) => {
                a = a.fullName != null ? a.fullName.toString() : "";
                b = b.fullName != null ? b.fullName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Email',
            dataIndex: 'emailAddress',
            className: "width140",
            sorter: (a, b) => {
                a = a.emailAddress != null ? a.emailAddress.toString() : "";
                b = b.emailAddress != null ? b.emailAddress.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return <a href={`mailto:${text}`}>{text}</a>
            },
        },
        {
            title: 'Zip Code',
            dataIndex: 'zipCode',
            className: "width120",
            sorter: (a, b) => {
                a = a.zipCode != null ? a.zipCode.toString() : "";
                b = b.zipCode != null ? b.zipCode.toString() : "";
                return a.localeCompare(b);
            },
            render: (text) => {
                return < a href={`tel:${phoneNumber(text)}`} > {text}</a>
            },

        },

        {
            title: 'Delivery Date',
            dataIndex: 'deliveryDate',
            className: "width140",
            sorter: (a, b) => {
                a = a.deliveryDate != null ? a.deliveryDate.toString() : "";
                b = b.deliveryDate != null ? b.deliveryDate.toString() : "";
                return a.localeCompare(b);
            },
        },

        {
            title: 'No. of Devices',
            dataIndex: 'deviceCount',
            className: "width120",
            sorter: (a, b) => {
                a = a.deviceCount != null ? a.deviceCount.toString() : "";
                b = b.deviceCount != null ? b.deviceCount.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Action',
            dataIndex: 'RepRequestsAction',
            className: "width140 textCenter",

        },


    ],


}